import { Col, Row } from "antd";
import cls from "classnames";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import supportImage from "../../assets/support/support.png";
import { getCognitoUserData } from "../../features/auth/authSlice";
import { selectCompany } from "../../features/company/companySlice";
import { fetchUser, selectUser } from "../../features/users/usersSlice";
import { ProfileBase } from "../common/Layouts/ProfileBaseLyt";
import { CardData } from "./CardItem";
import { Section } from "./Section";
import styles from "./support.module.scss";

import winzipIcon from '../../assets/support/winzip.webp';
import winrarIcon from '../../assets/support/rar.png';
import acrobatIcon from '../../assets/support/acrobat.svg';
import chormeIcon from '../../assets/support/chrome-logo.svg';
import firefoxIcon from '../../assets/support/firefox.png';
import operaIcon from '../../assets/support/opera.png';
import safariIcon from '../../assets/support/safari.png';

const browsers: CardData[] = [
  {
    logo: chormeIcon,
    title: "Google Chrome",
    description: "Este navegador es compatible con la plataforma Teurona.",
    link: "https://www.google.com/chrome/",
  },
  {
    logo: firefoxIcon,
    title: "Mozilla Firefox",
    description: "Este navegador es compatible con la plataforma Teurona.",
    link: "https://www.mozilla.org/es-ES/firefox/new/",
  },
  {
    logo: operaIcon,
    title: "Opera",
    description: "Este navegador es compatible con la plataforma Teurona.",
    link: "https://www.opera.com/es",
  },
  {
    logo: safariIcon,
    title: "Safari",
    description: "Este navegador es compatible con la plataforma Teurona.",
    link: "https://support.apple.com/es-lamr/HT204416",
  },
];

const compressors: CardData[] = [
  {
    logo: winrarIcon,
    title: "Winrar",
    description: "Este compresor es compatible con la plataforma Teurona.",
    link: "https://www.winrar.es/descargas",
  },
  {
    logo: winzipIcon,
    title: "Winzip",
    description: "Este compresor es compatible con la plataforma Teurona.",
    link: "https://www.winzip.com/win/es/prod_down.html",
  },
];

const other: CardData[] = [
  {
    logo: acrobatIcon,
    title: "Adobe reader",
    description: "Este software es compatible con la plataforma Teurona.",
    link: "https://get.adobe.com/reader/",
  },
];

interface SupportProps {}

export const Support: React.FunctionComponent<SupportProps> = () => {
  const cognitoUserData = useSelector(getCognitoUserData);
  const cognitoUsername = cognitoUserData
    ? cognitoUserData["cognito:username"]
    : null;
  const dispatch = useDispatch();
  const userFromStore = useSelector(selectUser(cognitoUsername));
  const companyFromStore = useSelector(
    selectCompany(userFromStore?.company ?? "")
  );
  useEffect(() => {
    dispatch(fetchUser(cognitoUsername));
  }, [dispatch, cognitoUsername]);

  const contactEmail =
    companyFromStore?.supportEmail ?? companyFromStore?.contactInfo.email;

  return (
    <ProfileBase panelHeight={styles.panel}>
      <div className={styles.mastheadContainer}>
        <Row className={styles.masthead} gutter={16}>
          <Col span={14} className={styles.left}>
            <div className={styles.titleContainer}>
              <h1 className={styles.title}>Soporte técnico</h1>
              <div className={styles.info}>
                En caso que necesites ayuda o tengas algún inconveniente
                accediendo a todos los servicios de la plataforma, ponte en
                contacto con <span className={styles.mail}>{contactEmail}</span>
              </div>
            </div>
          </Col>
          <Col span={10} className={styles.right}>
            <div className={styles.imageContainer}>
              <img
                className={cls(styles.image)}
                src={supportImage}
                alt="support"
              />
            </div>
          </Col>
        </Row>
      </div>
      <Section cards={browsers} title="Navegadores compatibles" />
      <Section cards={compressors} title="Compresores" />
      <Section cards={other} title="Otro software" />
    </ProfileBase>
  );
};
